import React, { useState } from 'react';
import { motion } from 'framer-motion';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import "../css/Burbuja.css";

const icons = [
  <LightbulbOutlinedIcon fontSize="large" className="custom-icon" />,
  <ShieldOutlinedIcon fontSize="large" className="custom-icon" />,
  <DiscountOutlinedIcon fontSize="large" className="custom-icon" />
];

const Burbuja = (props) => {
  const [isRevealed, setIsRevealed] = useState(false);

  const handleClick = () => {
    setIsRevealed(true);
  };

  return (
    <motion.div
      className={`burbuja ${isRevealed ? "revealed" : ""}`}
      onClick={handleClick}
      initial={{ backgroundColor: 'rgb(220, 220, 220)', opacity: 1 }}
      animate={{
        backgroundColor: isRevealed ? 'rgb(241, 241, 241)' : 'rgb(220, 220, 220)',
      }}
      transition={{ duration: 0.5 }}
    >
      {!isRevealed ? (
        <motion.div
          className="icon-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {icons[props.count % icons.length]} {/* Selecciona el ícono basado en el índice */}
        </motion.div>
      ) : (
        <motion.div
          className="content-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <h1>{props.count + 1}•</h1>
          <p>{props.content}</p>
        </motion.div>
      )}
    </motion.div>
  );
};

export default Burbuja;
